module.exports = __webpack_public_path__ + "static/media/120.46df6c17.jpg";